import { getEmpresaId } from '@/modules/shared/storage';

export const getListagemJasperParams = (pagination) => {
  const empresaId = getEmpresaId();
  return {
    ID: empresaId,
    nomeRelatorio: 'listagem_oss/listagem_oss',
    DATA_CRIACAO_INICIAL: pagination.creationInitialDate,
    DATA_CRIACAO_FINAL: pagination.creationEndDate,
    DATA_ENCERRAMENTO_INICIAL: pagination.closingInitialDate,
    DATA_ENCERRAMENTO_FINAL: pagination.closingEndDate,
    STATUS: pagination.status,
    USUARIOS_IDS: pagination.users || '',
    SERVICOS_IDS: pagination.servicos || '',
    CLIENTES_IDS: pagination.clientes || '',
  };
};
